var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"100%","height":"100%","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{staticStyle:{"fill":"currentColor"},attrs:{"d":"M0 11H18V13H0V11ZM0 4H18V9H0V4ZM0 0H18V2H0V0Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }